import { GaiaConstants } from '@gaiaEmployees/Utilities/GaiaConstants';
import { pageTitleStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsPageTitle";
import { css } from "styled-components";

pageTitleStyles.titleText = {
    variant: "h1",
    size: 36,
    color: GaiaConstants.colors.green,
    fontFamily: 'LibreBaskerville',
    weight: "normal",
    css: css`
        margin-bottom: 5px;
    `
};
